/**
 * ****************************************************************************
 * @description     :   Export all midleware function of saga
 * @created at      :   2020/12/03
 * @created by      :   QuyPN - quy.pham@toploop.co
 * @package         :   dashlite-admin-react
 * @copyright       :   Copyright (c) TOPLOOP
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { all } from 'redux-saga/effects'
import dashboardSaga from './dashboard/saga';
import userSaga from './user/saga';
import holonSaga from './holon/saga';
import policySetting from './policy-setting/saga';
import termOfUse from './term-of-use/saga';
import privacyPolicy from './privacy-policy/saga';
import privatePolicy from './private-policy/saga';
import appSaga from './app/saga';
import faqSaga from './faq/saga';
import holonTemplateSaga from './holon-template/saga';
import menuManagementSaga from './menu-management/saga';
import messageSaga from './message/saga';
import holonInstanceSaga from './holon-instance/saga';
import alarmHolonTemplateSaga from './alarm-holon-setting/saga';
import hexServiceSaga from './hex-service/saga';
import blInstanceSaga from './bl-instance/saga';
import alarmSaga from './alarm/saga';
import homeSaga from './home/saga';
import inquirySaga from './inquiry/saga';
import productSaga from './product/saga';
import warehouseSaga from './warehouse/saga';
import senderSaga from './sender/saga';
import stockSaga from './stocks/saga';
import receiverSaga from './receiver/saga';
import addressSaga from './address/saga';
import walletSaga from './wallet/saga';
import cargoSaga from './cargo/saga';
import fareCalculation from "./freight-calculation/saga";
import ocrSaga from './ocr/saga';
import bpFareSaga from './bp-fare/saga';
import warehouseInSaga from './warehouse-in/saga';
import transactionSaga from './transaction/saga';
import orderSaga from './order/saga';
import systemSettingSaga from './system-setting/saga';

/**
 * import saga of other components
 */

/**
 * Fork all function in saga midleware
 * -----------------------------------------
 * @author : QuyPN - 2020/12/03 - create
 * @access : public
 */
export default function* rootSaga() {
    yield all([
        dashboardSaga(),
        holonSaga(),
        userSaga(),
        policySetting(),
        termOfUse(),
        privacyPolicy(),
        privatePolicy(),
        appSaga(),
        faqSaga(),
        holonTemplateSaga(),
        menuManagementSaga(),
        messageSaga(),
        holonInstanceSaga(),
        alarmHolonTemplateSaga(),
        hexServiceSaga(),
        blInstanceSaga(),
        alarmSaga(),
        homeSaga(),
        inquirySaga(),
        productSaga(),
        warehouseSaga(),
        senderSaga(),
        receiverSaga(),
        addressSaga(),
        stockSaga(),
        walletSaga(),
        cargoSaga(),
        ocrSaga(),
        warehouseInSaga(),
        fareCalculation(),
        transactionSaga(),
        orderSaga(),
        systemSettingSaga(),
        bpFareSaga(),
    ]);
}
